import * as React from 'react';
import PosStore from '../../../stores/PosStore';
import * as _ from 'lodash';
import TypeAheadDD from './TypeaheadDropdown.react';

function withProducts(WrappedComponent) {
    return class withProducts extends React.Component {
        constructor(props) {
            super(props);

            this.onStoreChange = this.onStoreChange.bind(this);
            this.formatData = this.formatData.bind(this);
            this.onFilterChange = this.onFilterChange.bind(this);

            this.state = {
                filteredItems: this.formatData(PosStore.getState().products),
                filter: '',
            };
        }

        componentDidMount() {
            PosStore.addChangeListener(this.onStoreChange);
        }

        componentWillUnmount() {
            PosStore.removeChangeListener(this.onStoreChange);
        }

        onStoreChange(data) {
            //This is not the right way to do this
            this.setState({ filteredItems: this.formatData(PosStore.getState().products, this.state.filter), loading: false });
        }

        onFilterChange(filter) {
            
            this.setState({
                filter,
                filteredItems: this.formatData(PosStore.getState().products, filter),
            });
        }

        getSelected() {
            let selectedItem = _.find(PosStore.getState().products, x => x.ProductId === this.props.value);
            if(selectedItem) {

            
            const Subtitle = this.props.showDetail ? <div>
                    <div style={{width: '49%', display: 'inline-block'}}>SKU: {selectedItem.Sku}</div>
                    <div style={{ display: 'inline-block'}}>Strain: { selectedItem.Strain || 'None'}</div>
                </div> : null;
                const Name = `${selectedItem.Name}${(selectedItem.AlternateName || '').length > 0 ? ` / ${selectedItem.AlternateName}` : ''}`
                const searchString = `${selectedItem.Sku} ${selectedItem.Strain}`;
                
                return {
                    title : Name,
                    subtitle : Subtitle,
                    value : selectedItem.ProductId,
                    searchString,
                };
            } else {
                return null;
            }
        }

        onRefresh(){
            
        }

        formatData(items, filter) {
            
            if(filter) {
                filter = filter.toLowerCase();
                items = items.filter(x => {
                    return (
                        (x.Sku && x.Sku.toString().toLowerCase().indexOf(filter) !== -1) ||
                        (x.Strain && x.Strain.toString().toLowerCase().indexOf(filter) !== -1) ||
                        (x.Name && x.Name.toString().toLowerCase().indexOf(filter) !== -1) || 
                        (x.AlternateName && x.AlternateName.toString().toLowerCase().indexOf(filter) !== -1) 
                    );
                });
            }

            if(this.props.onlyProducts) {
                items = _.filter(items, x => !x.IsCoupon || x.IsCoupon.toLowerCase() !== 'yes');
            }

            items = _.orderBy(items, 'Name');

            if(this.props.limitItems) {
                const subItems = [];
                for(var i = 0; i < Math.min(this.props.limitItems, items.length); i++) {
                    subItems.push(items[i]);
                }

                items = subItems;
            }

            items = _(items)
            .map(x => {
                const Subtitle = this.props.showDetail ? <div>
                    <div style={{width: '49%', display: 'inline-block'}}>SKU: {x.Sku}</div>
                    <div style={{ display: 'inline-block'}}>Strain: { x.Strain || 'None'}</div>
                </div> : null;
                const Name = `${x.Name}${(x.AlternateName || '').length > 0 ? ` / ${x.AlternateName}` : ''}`
                const searchString = `${x.Sku} ${x.Strain}`;
                
                return {
                    title : Name,
                    subtitle : Subtitle,
                    value : x.ProductId,
                    searchString,
                };
            })
            .value();
            return items || [];
        }

        render() {
            return PosStore.getState().products.length === 0 ? 
            <i className='fa fa-spinner fa-pulse' />
            :
             <WrappedComponent 
                        {...this.props} 
                        selected={this.getSelected()}
                        subtitle={this.props.showDetail} 
                        options={this.state.filteredItems} 
                        onFilterChange={this.onFilterChange}
                        onRefresh={() => {this.onRefresh()} }
                    />;
        }
    };
}

export const TypeAheadDDWithProducts = withProducts(TypeAheadDD);


// WEBPACK FOOTER //
// ./ui_src/app/components/form/dropdown/TypeAheadWithProducts.react.jsx